import React, { useContext } from "react";
import { Row, Col} from "react-bootstrap";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import SecureModuleIndex from "../secure/SecureModuleIndex";
import bgImage from "../../images/loginBackgrounds/unsplash.png";
import bgBottom from "../../images/loginBackgrounds/bottom-mtn.png";
import mtnLogo from "../../images/DEQ_Logos/Mountain-Logo-Utah-DW-2.svg";
import {Button} from "@utahdts/utah-design-system";
import "@utahdts/utah-design-system-header/css";

const RequestAccess = (props) => {

  const { user } = useContext(UserContext);

  const buttonStyle = {
    margin: "10px", 
    borderRadius: "25px", 
    cursor: "pointer", 
    fontSize: "16px", 
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center" 
  };

  const bottomSectionStyle = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundImage: `url(${bgBottom})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
  };

  const bottomContentStyle = {
    textAlign: "center",
    maxWidth: "80%",
    margin: "auto",
    color: "#157995",
    fontSize: "28px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", 
    marginTop: "60px"
  };

  const handlePortalUserClick = () => {
    window.location.href = '/public/portal-access-form';
  };

  const handleStaffUserClick = () => {
    window.location.href = '/public/staff-access-form';
  };

  return (
    <>
      {user.isPublic ? (
        <Row>
          <Col>
            <div id="landingPageContainer">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: "100vw", backgroundImage: `url(${bgImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
                <div style={{ paddingBottom: "80px", alignItems: "center" }}>
                  <div style={{ textAlign: "center", maxWidth: "60%", margin: "auto" }}>
                    <img src={mtnLogo} alt='Mountain Logo' style={{ maxWidth: "100%", objectFit: "contain" }} />
                  </div>
                  <br/>
                  <h1 style={{ maxWidth: "80%", textAlign: "center", fontWeight: "bold", fontSize: "42px", color: "#fff", margin: "auto", objectFit: "contain", textShadow: "0 1px 4px rgba(0,0,0,0.9), 0 0 8px rgba(0,0,0,0.7)", backgroundColor: "rgba(20,121,148,0.01)" }}>
                    Request Access
                  </h1>
                  <br/>
                </div>
                <div style={bottomSectionStyle}>
                  <div style={bottomContentStyle}>
                    <div style={buttonContainerStyle} className="utah-design-system">
                      <Button appearance="solid" color="primary" style={buttonStyle} onClick={() => {handlePortalUserClick()}}>
                        As Portal User
                      </Button>
                      <Button appearance="solid" color="primary" style={buttonStyle} onClick={() => {handleStaffUserClick()}}>
                        As Staff User
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <SecureModuleIndex />
      )}
    </>
  );
};
export default RequestAccess;
